//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useEffect, useRef, useState } from 'react';

// *** MUI / STYLE ***
import { useTheme } from '@mui/material/styles';
import { 
  SignalWifiStatusbar4Bar,
  SignalWifiBad,
  SignalWifiStatusbarConnectedNoInternet4,
} from '@mui/icons-material';

// === COMPONENTS ===
import Styled from 'components/Styled/Styled';

// === HOOKS ===
import { OnlineStatus, useSession } from 'pages/PageManager/components/SessionContext';

//#endregion

//-----------------------------------------------------------------
export function IconWebsocketConnection( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { styles } = props;

  const theme = useTheme();

  const { online_status } = useSession();

  const [ is_open, setIsOpen  ] = useState( false );
  const [ message, setMessage ] = useState( '' );
  const [ color  , setColor   ] = useState( theme.palette.primary.main );

  const Icon = online_status == OnlineStatus.CONNECTED      ? SignalWifiStatusbar4Bar
             : online_status == OnlineStatus.DISCONNECTED   ? SignalWifiBad
             : online_status == OnlineStatus.RECONNECT_FAIL ? SignalWifiBad
             : online_status == OnlineStatus.RECONNECTING   ? SignalWifiStatusbarConnectedNoInternet4
             : SignalWifiBad;
             
  const ref_timeout_close = useRef(null);

  //#endregion

  //#region [STYLES]

  const position   = { position: 'absolute', top: '60px', right: '20px', zIndex: 1000 };
  const size       = { width: 'fit-content', height: '30px' };
  const center     = { alignItems: 'center' };
  const padding    = { padding: '4px', paddingLeft: '10px', paddingRight: '10px' };
  const background = { background: color };
  const border     = { borderRadius: '5px' };
  const is_visible = { display: is_open ? 'flex' : 'none' };

  //#endregion

  //#region [EFFECT]

  useEffect( () => {

  }, [] );

  useEffect( () => {
    switch( online_status ) {
      case OnlineStatus.DEFAULT : {
        setMessage('');
        setColor( theme.palette.primary.main );
        setIsOpen( false );
        closeTimer();
      } break;
      case OnlineStatus.DISCONNECTED : {
        setMessage('You have disconnected from the server.');
        setColor( theme.palette.error.main );
        setIsOpen( true );
        closeTimer();
      } break;
      case OnlineStatus.RECONNECTING : {
        setMessage('Attempting to reconnect to the server.');
        setColor( 'orange' );
        setIsOpen( true );
        closeTimer();
      } break;
      case OnlineStatus.RECONNECT_FAIL : {
        setMessage('Failed to reconnect to the server.');
        setColor( theme.palette.error.main );
        setIsOpen( true );
        closeTimer();
      } break;
      case OnlineStatus.CONNECTED : {
        setMessage('Connected to the server.');
        setColor( theme.palette.success.main );
        setIsOpen( true );
        closeTimer();
      } break;
    }
  }, [online_status] );

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onMouseOver() {
    //-----------------------------------------------------------------
    setIsOpen( true );
  }

  //-----------------------------------------------------------------
  function onMouseLeave() {
    //-----------------------------------------------------------------
    setIsOpen( false );
  }

  //#endregion

  //#region

  //-----------------------------------------------------------------
  function closeTimer() {
    //-----------------------------------------------------------------
    clearTimeout( ref_timeout_close.current );

    ref_timeout_close.current = setTimeout( () => {
      setIsOpen( false );
    }, 5000 );
  }

  //#endregion

  return (
    <>
      <Icon style={{color}} onMouseOver={onMouseOver} onMouseLeave={onMouseLeave} />
      <Styled styles={[is_visible, position, size, padding, center, background, border]}>
        {message}
      </Styled>
    </>
  )
}